/**
 * Onboarding progress predicates — the funnel signals shared by the
 * onboarding UI (`@mytour/onboarding`) and the analytics session watcher
 * (`@mytour/platform`, which cannot depend on `@mytour/onboarding`).
 */
/**
 * Vrai quand toutes les mentions légales requises pour émettre un document sont renseignées.
 * Prend `Pick<ICompany, "legal">` : un appelant qui n'a que `CompanyLegalSetting` (#1200)
 * n'a plus besoin d'un cast non sûr pour satisfaire la signature.
 */
export function isLegalInfoComplete(company) {
    const { legal } = company;
    return Boolean(legal.legalName &&
        legal.companyType &&
        legal.siret &&
        legal.administrativeAddress.zipCode &&
        legal.administrativeAddress.city &&
        legal.administrativeAddress.streetAddress);
}
/**
 * True when the account can emit its first document: at least one customer,
 * at least one service, and complete legal info.
 */
export function isReadyToInvoice(account, company) {
    return (account.stats.customers > 0 &&
        account.stats.serviceDescriptions > 0 &&
        isLegalInfoComplete(company));
}
//# sourceMappingURL=onboardingProgress.js.map